import { Link } from "react-router-dom";
import { motion } from "framer-motion";
import { Container, Section, PageHero, SectionHeading, CtaBanner, MapPin, ArrowRight } from "../components/common";
import { useLocations } from "../lib/api";
import { useSeo, breadcrumbLd } from "../lib/seo";

export default function Locations() {
 const { data: locations = [] } = useLocations();
 useSeo({
 title: "Service Areas | Auto Repair Across Riverside County | RPM Auto Repair",
 description: "RPM Auto Repair serves Riverside (92508) and nearby communities, plus the Murrieta & Temecula area, including Moreno Valley, Jurupa Valley, Perris, Norco, Corona, Colton & more, with honest, ASE-certified auto repair.",
 path: "/service-areas",
 jsonLd: [breadcrumbLd([{ name: "Home", path: "/" }, { name: "Service Areas", path: "/service-areas" }])],
 });
 return (
 <>
 <PageHero eyebrow="Proudly Local" title="Serving Riverside County & Beyond"
 subtitle="From our shop in the 92508 area, we serve drivers within roughly a 20-mile radius, plus the Murrieta and Temecula area. Honest, certified auto care close to home."
 image="https://images.pexels.com/photos/4116170/pexels-photo-4116170.jpeg?auto=compress&cs=tinysrgb&w=1400"
 crumbs={[{ name: "Home", path: "/" }, { name: "Service Areas", path: "/service-areas" }]} />
 <Section>
 <Container>
 <SectionHeading eyebrow="Where We Serve" title="Find Auto Repair Near You" />
 <div className="grid gap-6 sm:grid-cols-2 lg:grid-cols-3">
 {locations.map((l, i) => (
 <motion.div key={l.slug} initial={{ opacity: 0, y: 20 }} whileInView={{ opacity: 1, y: 0 }} viewport={{ once: true }}
 transition={{ duration: 0.4, delay: (i % 3) * 0.08 }}>
 <Link to={`/service-areas/${l.slug}`} data-testid={`location-${l.slug}`}
 className="group flex h-full flex-col overflow-hidden rounded-xl border border-white/10 bg-steel transition-all hover:-translate-y-1 hover:border-primary/50">
 <div className="relative h-40 overflow-hidden">
 <img src={l.image} alt={`Auto repair in ${l.name}, CA`} loading="lazy" className="h-full w-full object-cover opacity-60 transition-transform duration-500 group-hover:scale-110" />
 <div className="absolute inset-0 bg-gradient-to-t from-steel to-transparent" />
 </div>
 <div className="flex flex-1 flex-col p-5">
 <h3 className="flex items-center gap-2 font-display text-xl text-white group-hover:text-primary"><MapPin size={17} className="text-primary" /> {l.name}, CA</h3>
 <p className="mt-2 flex-1 text-sm text-muted-foreground">Honest, ASE-certified auto repair {l.distance !== "0 mi" ? `just ${l.distance} away` : "right here at home"}.</p>
 <span className="mt-4 inline-flex items-center gap-1.5 text-sm font-semibold text-primary">View Area <ArrowRight size={14} className="transition-transform group-hover:translate-x-1" /></span>
 </div>
 </Link>
 </motion.div>
 ))}
 </div>
 </Container>
 </Section>
 <CtaBanner />
 </>
 );
}
